function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.287,
    height: 8.618,
    viewBox: "0 0 8.287 8.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.4 0.566)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "#4a4f55"
    },
    d: "M14.987,18H7.5",
    transform: "translate(-7.5 -14.257)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#4a4f55",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.8px"
    },
    d: "M11.244,14.987,7.5,11.243,11.244,7.5",
    transform: "translate(-7.5 -7.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.048054ef744d04f3fe4726a0cb42600a.svg";
export { ForwardRef as ReactComponent };